<div class="condensate-toggle-container flex flex-col gap-[24px]">
  <div class="flex flex-row items-center w-full justify-between">
    <p>
      {{
        '+INSTALLATIONS.INSTALLATION.SRC.OPTIMIZATION.CONDENSATE_AVOIDANCE.TOGGLE_LABEL' | translate
      }}
    </p>
    <mat-slide-toggle
      #condensateToggle
      gtm="condensateAvoidanceToggle"
      gtmId="condensate-avoidance-toggle"
      gtmAction="onCondensateToggleChange"
      [disabled]="isToggleDisabled || !status?.properties?.active?.value"
      [checked]="getCondensateFeatures?.properties?.active?.value"
      (change)="onCondensateToggleChange(condensateToggle)"
    >
    </mat-slide-toggle>
  </div>
  <ng-container *ngIf="status | value2: featurePropertyKey.active as status">
    <p *ngIf="status === bool.True">
      {{
        '+INSTALLATIONS.INSTALLATION.SRC.OPTIMIZATION.CONDENSATE_AVOIDANCE.DESCRIPTION_ON'
          | translate
      }}
    </p>
    <p *ngIf="status !== bool.True">
      {{
        '+INSTALLATIONS.INSTALLATION.SRC.OPTIMIZATION.CONDENSATE_AVOIDANCE.DESCRIPTION_OFF'
          | translate
      }}
    </p>
  </ng-container>
</div>
